<div class="p-grid">
  @if (editable) {
    <div class="p-col-6 p-sm-12">
      <label>{{label}}</label>
      <div>
        <file-import
          [label]="fileTypes"
          [entityId]="entityId"
          [entityParent]="entityParent"
          [siteId]="siteId"
          [fileFormat]="'scanned'"
          (fileUploaded)="addDocument($event)">
        </file-import>
      </div>
    </div>
  }
  <div class="p-col-6 p-sm-12">
    <label>Download Links</label>
    @if (blobs.length > 0 && !downloading) {
      <div>
        @for (blob of blobs; track blob) {
          <div class="link">
            @if (editable) {
              <confirmation-button
                [iconsOnly]="true"
                actionIcon="pi pi-times" actionText="Delete"
                confirmIcon="pi pi-times" confirmText="Delete"
                cancelIcon="pi pi-minus-circle" cancelText="Cancel"
                size="sm"
                (actionConfirmed)="deleteFile(blob.id)">
              </confirmation-button>
            }
            <a (click)="downloadFile(blob.id)" target="_blank">{{blob.fileType | camelCase}} {{blob.index}}</a>
          </div>
        }
      </div>
    }
    <div>
      @if (blobs.length == 0 && !working) {
        <p>No files uploaded</p>
      }
    </div>
    @if (working) {
      <div>
        <p>
          <i class="pi pi-spin pi-spinner"></i>
          Checking for files...
        </p>
      </div>
    }
    @if (downloading) {
      <div>
        <p>
          <i class="pi pi-spin pi-spinner"></i>
          Retrieving file...
        </p>
      </div>
    }
  </div>
</div>

